<form [formGroup]="form" (submit)="onSubmit()">
	<div class="modal-header">
		<h2 class="modal-title" translate="CoordonnesBancairesForm.Title.Detail"></h2>
		<button type="button" class="modal-button-close fal fa-times" (click)="onClose()"></button>
	</div>

	<div class="modal-body">
		<h3 translate="CoordonnesBancairesForm.Title.DestinationVirement"></h3>
		<div class="row">
			<div class="col-4">
				<div class="form-group">
					<label class="form-label" translate="CoordonnesBancairesForm.DestinationVirement.DeviseAffaire"></label>
					<ng-select labelForId="field-deviseReferenceId"
							   formControlName="deviseReferenceId"
							   appendTo="body"
							   [class.is-invalid]="deviseReferenceIdField.dirty && deviseReferenceIdField.invalid"
							   [searchable]="true"
							   [placeholder]="'Forms.Placeholder.Select' | translate"
							   [notFoundText]="'NgSelect.NotFoundText' | translate"
							   [typeToSearchText]="'NgSelect.TypeToSearchText' | translate"
							   [loadingText]="'NgSelect.LoadingText' | translate"
							   [clearAllText]="'NgSelect.ClearAllText' | translate">
						<ng-option *ngFor="let devise of devises$ | async" [value]="devise.id">
							{{ devise.codeISO }} - {{ devise.libelle }}
						</ng-option>
					</ng-select>

					<form-control-feedback [field]="deviseReferenceIdField"></form-control-feedback>
				</div>
			</div>
			<div class="col-4">
				<div class="form-group">
					<label class="form-label form-label-required"
						   translate="CoordonnesBancairesForm.DestinationVirement.PaysBanqueBeneficiaire"></label>
					<ng-select labelForId="field-paysBanqueBeneficaireIdField"
							   formControlName="paysBanqueBeneficaireId"
							   appendTo="body"
							   [class.is-invalid]="paysBanqueBeneficaireIdField.dirty && paysBanqueBeneficaireIdField.invalid"
							   [searchable]="true"
							   [placeholder]="'Forms.Placeholder.Select' | translate"
							   [notFoundText]="'NgSelect.NotFoundText' | translate"
							   [typeToSearchText]="'NgSelect.TypeToSearchText' | translate"
							   [loadingText]="'NgSelect.LoadingText' | translate"
							   [clearAllText]="'NgSelect.ClearAllText' | translate"
							   [clearable]="false">
						<ng-option *ngFor="let currentPays of pays$ | async" [value]="currentPays.id">
							{{ currentPays.nom }}
						</ng-option>
					</ng-select>
					<form-control-feedback style="position: absolute" [field]="paysBanqueBeneficaireIdField"></form-control-feedback>
				</div>
			</div>
			<div class="col-4" *ngIf="isBO && !IsPlacements">
				<div class="custom-checkbox-group">
					<label for="field-saisieVirementManuscrit" class="custom-checkbox">
						<input id="field-saisieVirementManuscrit"
							   type="checkbox"
							   formControlName="saisieVirementManuscrit"
							   [class.is-invalid]="saisieVirementManuscritField.dirty && saisieVirementManuscritField.invalid"
							   (change)="clearOther('saisieVirementManuscrit')" />
						<span class="label-text" translate="CoordonnesBancairesForm.DestinationVirement.SaisieVirementManuscrit"></span>
					</label>
					<form-control-feedback [field]="saisieVirementManuscritField"></form-control-feedback>

					<label for="field-virementUrgent" class="custom-checkbox">
						<input id="field-virementUrgent"
							   type="checkbox"
							   formControlName="virementUrgent"
							   [class.is-invalid]="virementUrgentField.dirty && virementUrgentField.invalid"
							   (change)="clearOther('virementUrgent')" />
						<span class="label-text" translate="CoordonnesBancairesForm.DestinationVirement.VirementUrgent"></span>
					</label>
					<form-control-feedback [field]="virementUrgentField"></form-control-feedback>

					<!-- Case masquee a la demande du metier en attendant le passage de la norme ISO 20022 pain
					     a une version superieure (fonctionnalite livree par #17406). Le controle virementTarget
					     est conserve dans le formulaire : reactivation = decommenter ce bloc.
					<label *ngIf="isSepaZone" for="field-virementTarget" class="custom-checkbox">
						<input
							id="field-virementTarget"
							type="checkbox"
							formControlName="virementTarget"
							[class.is-invalid]="virementTargetField.dirty && virementTargetField.invalid"
							(change)="clearOther('virementTarget')"
						/>
						<span class="label-text" translate="CoordonnesBancairesForm.DestinationVirement.VirementTarget"></span>
					</label>
					<form-control-feedback [field]="virementTargetField"></form-control-feedback> -->
				</div>
			</div>
		</div>

		<h3 translate="CoordonnesBancairesForm.Title.CompteBancaireBeneficiaire"></h3>
		<div class="row">
			<div class="col-4">
				<div class="form-group">
					<ng-container *ngIf="!isSepaZone">
						<div class="custom-radio-group">
							<label for="field-iban" class="custom-radio" style="margin-right: 30px; display: inline-flex">
								<input class="form-check-input"
									   id="field-iban"
									   type="radio"
									   [value]="true"
									   (change)="onChangeIbanCB()"
									   [formControl]="isIbanCBField" />
								<span class="label-text form-label-required"
									  translate="CoordonnesBancairesForm.CompteBancaireBeneficiaire.IBAN"></span>
							</label>
							<label for="field-numCompte" class="custom-radio" style="margin-right: 30px; display: inline-flex">
								<input class="form-check-input"
									   id="field-numCompte"
									   type="radio"
									   [value]="false"
									   (change)="onChangeIbanCB()"
									   [formControl]="isIbanCBField" />
								<span class="label-text form-label-required"
									  translate="CoordonnesBancairesForm.CompteBancaireBeneficiaire.NumeroCompte"></span>
							</label>
						</div>
						<form-control-feedback [field]="isIbanCBField"></form-control-feedback>
					</ng-container>

					<ng-container *ngIf="isSepaZone || (!isSepaZone && isIbanCBField.value === true)">
						<label *ngIf="isSepaZone"
							   for="field-ibanBeneficiaire"
							   class="form-label form-label-required"
							   translate="CoordonnesBancairesForm.CompteBancaireBeneficiaire.Ibanbeneficiaire"></label>
						<input #iban
							   id="field-ibanBeneficiaire"
							   class="form-control"
							   type="text"
							   autocomplete="off"
							   formControlName="ibanBeneficiaire"
							   inputRestriction="alphanumericiban"
							   inputUppercaseType="['uppercase']"
							   iban
							   [ibanForm]="ibanBeneficiaireField"
							   [pays]="selectedPay"
							   [checkOnChangePays]="true"
							   [class.is-invalid]="ibanBeneficiaireField.dirty && ibanBeneficiaireField.invalid" />
						<form-control-feedback [field]="ibanBeneficiaireField"></form-control-feedback>
						<p *ngIf="addAutomaticCBForCompte && !ribAutoFillEdited" class="form-required-fields form-text-red mb-base">
							{{(isBO ? 'CoordonnesBancairesForm.InfoCBAddedAutomaticallyFOBO' : 'CoordonnesBancairesForm.InfoCBAddedAutomatically')| translate}}
						</p>
						<p *ngIf="addAutomaticCBForTiers && !addAutomaticCBForCompte && !ribAutoFillEdited" class="form-required-fields form-text-red mb-base">
							{{(isBO ? 'CoordonnesBancairesForm.InfoCBAddedAutomaticallyFOBO' : 'CoordonnesBancairesForm.InfoCBAddedAutomaticallyTiersFO')| translate}}
						</p>
					</ng-container>
					<ng-container *ngIf="!isSepaZone && isIbanCBField.value !== true">
						<input id="field-numeroCompte"
							   class="form-control"
							   type="text"
							   autocomplete="off"
							   formControlName="numeroCompte"
							   inputRestriction="numericwithoutformat"
							   [class.is-invalid]="numeroCompteField.dirty && numeroCompteField.invalid" />
						<form-control-feedback [field]="numeroCompteField"></form-control-feedback>
						<p *ngIf="addAutomaticCBForCompte && !ribAutoFillEdited" class="form-required-fields form-text-red mb-base">
							{{(isBO ? 'CoordonnesBancairesForm.InfoCBAddedAutomaticallyFOBO' : 'CoordonnesBancairesForm.InfoCBAddedAutomatically')| translate}}
						</p>
						<p *ngIf="addAutomaticCBForTiers && !addAutomaticCBForCompte && !ribAutoFillEdited" class="form-required-fields form-text-red mb-base">
							{{(isBO ? 'CoordonnesBancairesForm.InfoCBAddedAutomaticallyFOBO' : 'CoordonnesBancairesForm.InfoCBAddedAutomaticallyTiersFO')| translate}}
						</p>
					</ng-container>
				</div>
			</div>

			<div class="col-4">
				<div class="form-group">
					<label class="form-label"
						   [ngClass]="selectedPay?.codeEconomiqueModifiable ? 'form-label-required' : ''"
						   translate="CoordonnesBancairesForm.CompteBancaireBeneficiaire.CodeEconomique">
					</label>
					<ng-select labelForId="field-codeEconomiqueId"
							   formControlName="codeEconomiqueId"
							   appendTo="body"
							   [class.is-invalid]="codeEconomiqueIdField.dirty && codeEconomiqueIdField.invalid"
							   [searchable]="true"
							   [placeholder]="'Forms.Placeholder.Select' | translate"
							   [notFoundText]="'NgSelect.NotFoundText' | translate"
							   [typeToSearchText]="'NgSelect.TypeToSearchText' | translate"
							   [loadingText]="'NgSelect.LoadingText' | translate"
							   [clearable]="false">
						<ng-option *ngFor="let currentCode of groupesCodeEconomiqueList" [value]="currentCode.id">
							{{ currentCode.code }} - {{ currentCode.libelle }}
						</ng-option>
					</ng-select>
					<form-control-feedback style="position: absolute" [field]="codeEconomiqueIdField"></form-control-feedback>
				</div>
			</div>

			<div class="col-4" *ngIf="!isSepaZone">
				<div class="form-group">
					<label class="form-label form-label-required"
						   translate="CoordonnesBancairesForm.CompteBancaireBeneficiaire.DeviseCompteCredite"></label>
					<ng-select labelForId="field-deviseCompteCrediteId"
							   formControlName="deviseCompteCrediteId"
							   appendTo="body"
							   [class.is-invalid]="deviseCompteCrediteIdField.dirty && deviseCompteCrediteIdField.invalid"
							   [searchable]="true"
							   [placeholder]="'Forms.Placeholder.Select' | translate"
							   [notFoundText]="'NgSelect.NotFoundText' | translate"
							   [typeToSearchText]="'NgSelect.TypeToSearchText' | translate"
							   [loadingText]="'NgSelect.LoadingText' | translate"
							   [clearAllText]="'NgSelect.ClearAllText' | translate"
							   (change)="onChangeDeviseCompteCredite($event)"
							   [clearable]="false">
						<ng-option *ngFor="let devise of devises$ | async" [value]="devise.id">
							{{ devise.codeISO }} - {{ devise.libelle }}
						</ng-option>
					</ng-select>

					<form-control-feedback [field]="deviseCompteCrediteIdField"></form-control-feedback>
				</div>
			</div>
		</div>

		<div class="row col-12">
			<label for="field-libelleComplementaire"
				   [class]="editCBCompte ? 'form-label' : 'form-label form-label-required'"
				   translate="CoordonnesBancairesForm.CompteBancaireBeneficiaire.libelleComplementaire"></label>
			<textarea id="field-libelleComplementaire"
					  [formControl]="libelleComplementaireField"
					  inputUppercaseType="['uppercase','startWith']"
					  [startWith]="structure"
					  maxLength="140"
					  (dragstart)="onDrag($event)"
					  rows="2"></textarea>
			{{ 140 - libelleComplementaireField?.value?.length }} {{ 'CoordonnesBancairesForm.CaracteresRestants' | translate }}
		</div>
		<div *ngIf="libelleComplementaireField.hasError('minlength') && libelleComplementaireField.touched" class="text-danger">
			{{ 'CoordonnesBancairesForm.CompteBancaireBeneficiaire.libelleComplementaireInfo' | translate }}
		</div>
		<ng-container *ngIf="!isSepaZone">
			<br />
			<h3 translate="CoordonnesBancairesForm.Title.AdresseBeneficiaire"></h3>
			<div class="row col-12">
				<label for="field-adresseBeneficiaire"
					   [class]="isAdresseBeneficiaireRequired() ? 'form-label form-label-required' : 'form-label'"
					   translate="CoordonnesBancairesForm.AdresseBeneficiaire.Adresse"></label>
				<textarea id="field-adresseBeneficiaire"
						  inputRestriction="nomEmetteur"
						  [formControl]="adresseBeneficiaireField"
						  inputUppercaseType="['uppercase', 'withoutSpecialChars']"
						  maxLength="105"
						  [rows]="textAreaAdresseBenefeciareRows"></textarea>
				{{ 105 - adresseBeneficiaireField?.value?.length }} {{ 'CoordonnesBancairesForm.CaracteresRestants' | translate }}
			</div>
			<form-control-feedback [field]="adresseBeneficiaireField"></form-control-feedback>

			<br />
			<div class="row">
				<div class="col-4">
					<div class="form-group">
						<label class="form-label"
							   [class]="isPaysBeneficaireRequired() ? 'form-label form-label-required' : 'form-label'"
							   translate="CoordonnesBancairesForm.AdresseBeneficiaire.Pays">
						</label>
						<ng-select labelForId="field-paysBeneficaireIdField"
								   formControlName="paysBeneficaireId"
								   appendTo="body"
								   [class.is-invalid]="paysBeneficaireIdField.dirty && paysBeneficaireIdField.invalid"
								   [searchable]="true"
								   [placeholder]="'Forms.Placeholder.Select' | translate"
								   [notFoundText]="'NgSelect.NotFoundText' | translate"
								   [typeToSearchText]="'NgSelect.TypeToSearchText' | translate"
								   [loadingText]="'NgSelect.LoadingText' | translate"
								   [clearAllText]="'NgSelect.ClearAllText' | translate"
								   [clearable]="!selectedPay?.adresseBeneficiaireObligatoire">
							<ng-option *ngFor="let currentPays of pays$ | async" [value]="currentPays.id">
								{{ currentPays.nom }}
							</ng-option>
						</ng-select>
						<form-control-feedback style="position: absolute" [field]="paysBeneficaireIdField"></form-control-feedback>
					</div>
				</div>
			</div>

			<h3 translate="CoordonnesBancairesForm.Title.BanqueBeneficiaire"></h3>
			<div class="row">
				<div class="col-4">
					<div class="form-group">
						<label for="field-nomBanque"
							   class="form-label form-label-required"
							   translate="CoordonnesBancairesForm.BanqueBeneficiaire.Nom"></label>
						<input id="field-nomBanque"
							   class="form-control"
							   type="text"
							   autocomplete="off"
							   formControlName="nomBanque"
							   inputUppercaseType="['uppercase', 'withoutSpecialChars']"
							   [class.is-invalid]="nomBanqueField.dirty && nomBanqueField.invalid" />
						<form-control-feedback [field]="nomBanqueField"></form-control-feedback>
					</div>
				</div>

				<div class="col-8">
					<div>
						<label for="field-adresseBanque"
							   class="form-label form-label-required"
							   translate="CoordonnesBancairesForm.BanqueBeneficiaire.Adresse">
						</label>
						<textarea id="field-adresseBanque"
								  inputRestriction="nomEmetteur"
								  [formControl]="adresseBanqueField"
								  inputUppercaseType="['uppercase', 'withoutSpecialChars']"
								  maxLength="105"
								  [rows]="textAreaAdresseBanqueRows"></textarea>
						{{ 105 - adresseBanqueField?.value?.length }} {{ 'CoordonnesBancairesForm.CaracteresRestants' | translate }}
					</div>
					<form-control-feedback [field]="adresseBanqueField"></form-control-feedback>
				</div>
			</div>

			<div class="row">
				<div class="col-4">
					<div class="form-group">
						<label for="field-swiftBic"
							   [class]="!isSepaZone || deviseReferenceCompte != deviseReference ? 'form-label form-label-required' : 'form-label'"
							   translate="CoordonnesBancairesForm.BanqueBeneficiaire.SwiftBic"></label>
						<input id="field-swiftBic"
							   class="form-control"
							   type="text"
							   autocomplete="off"
							   formControlName="swiftBic"
							   inputRestriction
							   [fieldformControl]="swiftBicField"
							   inputUppercaseType="['uppercase']"
							   inputRestriction="alphanumeric"
							   swift
							   [swiftForm]="swiftBicField"
							   [pays]="selectedPay"
							   [checkOnChangePays]="true"
							   [class.is-invalid]="swiftBicField.dirty && swiftBicField.invalid" />
						<form-control-feedback [field]="swiftBicField"></form-control-feedback>
					</div>
				</div>

				<div class="col-4" *ngIf="!isSepaZone && selectedPay?.codeABA">
					<div class="form-group">
						<label for="field-abaRoutingNumber"
							   [class]="!isSepaZone && selectedPay?.codeABA ? 'form-label form-label-required' : 'form-label'"
							   translate="CoordonnesBancairesForm.BanqueBeneficiaire.RoutingNumber"></label>
						<input id="field-abaRoutingNumber"
							   class="form-control"
							   type="text"
							   autocomplete="off"
							   formControlName="abaRoutingNumber"
							   inputRestriction="numericwithoutformat"
							   maxLength="9"
							   [class.is-invalid]="abaRoutingNumberField.dirty && abaRoutingNumberField.invalid" />
						<form-control-feedback [field]="abaRoutingNumberField"></form-control-feedback>
					</div>
				</div>
			</div>
		</ng-container>

		<ng-container *ngIf="isBO && !isSepaZone">
			<br />
			<h3 translate="CoordonnesBancairesForm.Title.Frais"></h3>
			<div class="custom-radio-group">
				<label *ngFor="let f of fraisList"
					   for="field-{{ buildInputId(f) }}"
					   class="custom-radio"
					   style="margin-right: 30px; display: inline-flex">
					<input id="field-{{ buildInputId(f) }}"
						   type="radio"
						   [value]="frais[f]"
						   formControlName="frais"
						   [class.is-invalid]="fraisField.dirty && fraisField.invalid"
						   class="form-check-input" />
					<span class="label-text">{{ 'CoordonnesBancairesForm.Frais.' + f | translate }}</span>
				</label>

				<!--
			<label class="custom-radio" style="margin-right: 30px;display: inline-flex;" for="field-beneficiaire">
				<input id="field-beneficiaire" class="form-check-input" type="radio" value="beneficiaire"
					formControlName="frais" [class.is-invalid]="fraisField.dirty && fraisField.invalid"/>
				<span class="label-text" translate="CoordonnesBancairesForm.Frais.Beneficiaire"></span>
			</label>
			<label class="custom-radio" style="margin-right: 30px;display: inline-flex;" for="field-emetteur">
				<input id="field-emetteur" class="form-check-input" type="radio" value="emetteur"
					formControlName="frais" [class.is-invalid]="fraisField.dirty && fraisField.invalid"/>
				<span class="label-text" translate="CoordonnesBancairesForm.Frais.Emetteur"></span>
			</label>
			<label class="custom-radio" style="margin-right: 30px;display: inline-flex;" for="field-partage">
				<input id="field-partage" class="form-check-input" type="radio" value="partage"
					formControlName="frais" [class.is-invalid]="fraisField.dirty && fraisField.invalid"/>
				<span class="label-text" translate="CoordonnesBancairesForm.Frais.Partage"></span>
			</label> -->
			</div>
			<form-control-feedback [field]="fraisField"></form-control-feedback>
		</ng-container>

		<br />

		<ng-container *ngIf="!isBO">
			<h3 [translate]="canAddDocument ? 'CoordonnesBancairesForm.Title.Documents.Ajout' : 'CoordonnesBancairesForm.Title.Documents.Liste'"></h3>
			<div class="row" [class.block-loader]="alfrescoDocumentsLoader.isLoading$ | async">
				<div class="col-12">
					<div class="form-group">
						<label class="form-label form-label-required"
							   [translate]="
								canAddDocument
									? 'CoordonnesBancairesForm.Documents.MessageAjout'
									: 'CoordonnesBancairesForm.Documents.MessageListe'
							"></label>
						<div>
							<loader-spinner [model]="alfrescoDocumentsLoader"></loader-spinner>
							<!-- <upload-document
							[alfrescoFiles]="alfrescoDocuments$ | async"
							[canAddDocument]="canAddDocument"
							[files]="documentsCB?.value"
							(fileDropped)="handleDocumentsSelection($event)"
							(deleteAlfrescoCBDocId)="onDeleteAlfrescoCBDocId($event)"
						>
						</upload-document> -->
							<upload-document-modal [isConsultMode]="isConsultMode"
												   #uploadDocumentModal
												   [forReUse]="true"
												   [isFromPageCB]="true"
												   [viewDocumentChips]="false"
												   [coordonneesBancairesFiles]="documentsCB?.value"
												   [coordonneesBancairesFilesFromAlfresco]="alfrescoDocuments$ | async"
												   [documentType]="typeCoordBancaire"
												   [deferAlfrescoDelete]="editCBCompte"
												   (fileDropped)="handleDocumentsSelection($event)"
												   (delete)="handleDeleteEmited($event)">
							</upload-document-modal>
						</div>
						<form-control-feedback [field]="documentsCB"></form-control-feedback>
					</div>
				</div>
			</div>
		</ng-container>
	</div>

	<div class="modal-footer">
		<button id="btn-cancel" type="button" class="btn btn-secondary" (click)="onClose()">
			<i class="far fa-times"></i>
			{{ 'Actions.Cancel' | translate }}
		</button>
		<button *ngIf="!isConsultMode" id="btn-save" type="submit" class="btn btn-primary">
			<i class="far fa-save"></i>
			{{ 'Actions.Save' | translate }}
		</button>
	</div>
</form>
